document.addEventListener("DOMContentLoaded", () => {
    const sliderContainer = document.querySelector(".article-slider__container");
    if (!sliderContainer) return;

    const slides = document.querySelectorAll(".article-card");
    const prevButton = document.querySelector(".slider-button--prev");
    const nextButton = document.querySelector(".slider-button--next");

    let currentSlide = 0;
    const slidesPerView = window.innerWidth < 768 ? 1 : 3;

    const dots = document.querySelectorAll(".slider-dot");

    function updateDots() {
        dots.forEach((dot, index) => {
            dot.classList.toggle("active", index === currentSlide);
        });
    }

    function goToSlide(index) {
        currentSlide = index;
        const slideWidth = slides[0].offsetWidth + 24; // Include gap
        sliderContainer.scrollTo({
            left: slideWidth * index,
            behavior: "smooth",
        });
        updateDots();
        updateButtons();
    }

    function updateButtons() {
        prevButton.style.opacity = currentSlide === 0 ? "0" : "1";
        prevButton.style.pointerEvents = currentSlide === 0 ? "none" : "auto";

        nextButton.style.opacity =
            currentSlide >= slides.length - slidesPerView ? "0" : "1";
        nextButton.style.pointerEvents =
            currentSlide >= slides.length - slidesPerView ? "none" : "auto";
    }

    if (sliderContainer) {
        prevButton.addEventListener("click", () => {
            if (currentSlide > 0) {
                goToSlide(currentSlide - 1);
            }
        });

        nextButton.addEventListener("click", () => {
            if (currentSlide < slides.length - slidesPerView) {
                goToSlide(currentSlide + 1);
            }
        });

        // Handle scroll end for updating dots
        let scrollTimeout;
        sliderContainer.addEventListener("scroll", () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                const slideWidth = slides[0].offsetWidth + 24;
                currentSlide = Math.round(sliderContainer.scrollLeft / slideWidth);
                updateDots();
                updateButtons();
            }, 150);
        });

        // Initial setup
        updateButtons();
        // Handle window resize
        window.addEventListener("resize", () => {
            const newSlidesPerView = window.innerWidth < 768 ? 1 : 3;
            if (newSlidesPerView !== slidesPerView) {
                goToSlide(0);
            }
        });
    }
});
